import "../button/btn.css"

import {
  BaseComponentProps,
  COMPONENT_KIND_CLASS_MAP,
  COMPONENT_SIZE_CLASS_MAP,
  ComponentKind,
  ComponentSize,
  enhanceElementWithClassName,
} from "@utilities/buttonLinkShared"
import classNames from "classnames"
import React, { AnchorHTMLAttributes, forwardRef } from "react"

export interface BaseLinkElementProps
  extends BaseComponentProps,
    Omit<
      AnchorHTMLAttributes<HTMLAnchorElement>,
      keyof BaseComponentProps | "children"
    > {
  children?: React.ReactNode
  external?: boolean
  href: string
  kind?: ComponentKind
  label?: React.ReactNode
}

const buildComponentClassName = (
  size?: ComponentSize,
  kind?: ComponentKind,
  fullWidth?: boolean,
  className?: string
): string => {
  return classNames(
    kind && "tds-btn",
    size && size !== "md" && kind && COMPONENT_SIZE_CLASS_MAP[size],
    kind && COMPONENT_KIND_CLASS_MAP[kind],
    fullWidth && "tds-btn--full-width",
    className
  )
}

export const BaseLink = forwardRef<HTMLAnchorElement, BaseLinkElementProps>(
  (
    {
      children,
      className,
      external = false,
      fullWidth,
      href,
      kind,
      label,
      prefix,
      size,
      suffix,
      ...restProps
    }: BaseLinkElementProps,
    ref
  ) => {
    const combinedClassName = buildComponentClassName(
      size,
      kind,
      fullWidth,
      className
    )

    const prefixElement = enhanceElementWithClassName(prefix, "prefix")
    const suffixElement = enhanceElementWithClassName(suffix, "suffix")
    const externalProps = external
      ? { rel: "noopener noreferrer", target: "_blank" }
      : {}

    return (
      <a
        href={href}
        className={combinedClassName}
        ref={ref}
        {...restProps}
        {...externalProps}
      >
        {prefixElement}
        {label || children}
        {suffixElement}
      </a>
    )
  }
)

BaseLink.displayName = "BaseLink"
